import formData from "./formData";

const {
  formField: { name, dateOfBirth },
} = formData;

const initialValues = {
  [name.name]: "",
  [dateOfBirth.name]: "",
};

export default initialValues;
